import MobileDesktopRedirectPage from './MobileDesktopRedirectPage'

const MobileLayout = () => {
    return (
        <div className='flex flex-col h-full' style={{ height: 'calc(100vh - 56px)', backgroundColor: '#000000' }}>
            {/* Mobile Bottom Navigation */}
            {/* {isMobile && <MobileBottomNav />} */}

            {/* Mobile Drawers */}
            {/* <MobileLeftDrawer isOpen={isLeftDrawerOpen} onClose={closeLeftDrawer} /> */}
            {/* <MobileRightDrawer isOpen={isRightDrawerOpen} onClose={closeRightDrawer} /> */}

            {/* Mobile App Banner */}
            <MobileDesktopRedirectPage /><fieldset></fieldset>
        </div>
    )
}

export default MobileLayout